import { Component, ChangeDetectionStrategy, inject, input, computed } from '@angular/core';

import { ButtonColor, ButtonComponent } from '@pedix-workspace/angular-ui-button';
import {
  IconCopyComponent,
  IconShareComponent,
  IconWhatsappComponent,
} from '@pedix-workspace/angular-ui-icons';

import { TranslocoDirective, TranslocoService } from '@jsverse/transloco';
import { WhatsappLinkService } from '@pedix-workspace/angular-utils';
import {
  NgbDropdown,
  NgbDropdownItem,
  NgbDropdownMenu,
  NgbDropdownToggle,
} from '@ng-bootstrap/ng-bootstrap';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-share-button',
  templateUrl: './share-button.component.html',
  styleUrls: ['./share-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    TranslocoDirective,
    ButtonComponent,
    IconShareComponent,
    NgbDropdown,
    NgbDropdownItem,
    NgbDropdownMenu,
    NgbDropdownToggle,
    NgbDropdownItem,
    IconWhatsappComponent,
    IconCopyComponent,
    ClipboardModule,
  ],
})
export class ShareButtonComponent {
  private whatsappLinkService = inject(WhatsappLinkService);
  private toastrService = inject(ToastrService);
  private t = inject(TranslocoService);

  readonly url = input.required<string>();
  readonly shareText = input<string>();
  readonly buttonColor = input.required<ButtonColor>();

  readonly whatsappShareLink = computed(() => {
    const text = this.shareText() ? [this.shareText(), this.url()].join('\n') : this.url();

    return this.whatsappLinkService.getTrustedLink({ text });
  });
  readonly whatsappLinkHttpTarget = computed(() => {
    return this.whatsappLinkService.getWhatsappLinkHttpTarget();
  });

  onCopiedSuccess() {
    this.toastrService.success(this.t.translate('global.copySuccess'));
  }
}
